import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-372578bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-container" }
const _hoisted_2 = {
  ref: "scrollContainerRef",
  class: "notice-list",
  role: "main",
  "aria-label": "공지사항 목록"
}
const _hoisted_3 = {
  key: 0,
  role: "list",
  "aria-label": "공지사항 목록"
}
const _hoisted_4 = ["aria-label", "aria-expanded", "onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "symbol-new",
  "aria-hidden": "true"
}
const _hoisted_7 = ["datetime"]
const _hoisted_8 = {
  key: 0,
  class: "notice-content-wrapper",
  "aria-label": "공지사항 내용"
}
const _hoisted_9 = { class: "zoom-control-wrapper" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id", "innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "empty-item",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "공지사항 / 알림" }),
        _createElementVNode("main", _hoisted_2, [
          ($setup.noticeInfos.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.noticeInfos, (notice) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: notice.id,
                    role: "listitem",
                    class: "notice"
                  }, [
                    _createElementVNode("article", null, [
                      _createElementVNode("button", {
                        class: "notice-row",
                        "aria-label": `${$setup.noticeTitle(notice)} ${
                  notice.wasRead ? '읽음' : '새 글'
                } ${$setup.isSelectedNotice(notice.id) ? '펼쳐짐' : '접혀짐'}`,
                        "aria-expanded": $setup.isSelectedNotice(notice.id),
                        onClick: ($event: any) => ($setup.onClickNotice(notice.id, notice.wasRead))
                      }, [
                        _createElementVNode("header", _hoisted_5, [
                          _createElementVNode("header", null, _toDisplayString($setup.noticeTitle(notice)), 1 /* TEXT */),
                          (!notice.wasRead)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " N "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("time", {
                          class: "date",
                          datetime: notice.lastModifiedDate
                        }, _toDisplayString(notice.lastModifiedDate), 9 /* TEXT, PROPS */, _hoisted_7)
                      ], 8 /* PROPS */, _hoisted_4)
                    ]),
                    _createVNode(_Transition, {
                      appear: "",
                      name: "expand",
                      onEnter: $setup.onExpandEnter,
                      onLeave: $setup.onExpandLeave
                    }, {
                      default: _withCtx(() => [
                        ($setup.isSelectedNotice(notice.id))
                          ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode($setup["ZoomControl"], {
                                  landscape: true,
                                  "target-container-id": `notice-${notice.id}`,
                                  "target-content-id": `notice-content-${notice.id}`
                                }, null, 8 /* PROPS */, ["target-container-id", "target-content-id"])
                              ]),
                              _createElementVNode("div", {
                                id: `notice-${notice.id}`,
                                class: "notice-html-wrapper"
                              }, [
                                _createElementVNode("div", {
                                  id: `notice-content-${notice.id}`,
                                  innerHTML: $setup.DOMPurify.sanitize(notice.content),
                                  class: "notice-content",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.validateUrlLink && $setup.validateUrlLink(...args)))
                                }, null, 8 /* PROPS */, _hoisted_11)
                              ], 8 /* PROPS */, _hoisted_10)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                _hoisted_12
              ]))
            : (_openBlock(), _createBlock($setup["EmptyContent"], {
                key: 1,
                text: "공지사항이 없습니다"
              }))
        ], 512 /* NEED_PATCH */),
        ($setup.scrollContainerRef)
          ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
              key: 0,
              container: $setup.scrollContainerRef
            }, null, 8 /* PROPS */, ["container"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}